import React from 'react';
import '../style/SkeletonLoading.css';

const SkeletonLoading = () => {
  return (
    <div className="skeleton-dashboard">
      <div className="row ms-2 mb-3 gap-3">
        <div className="skeleton skeleton-welcome-banner"></div>
        <div className="skeleton skeleton-profile-card"></div>
      </div>
      <div className="skeleton skeleton-course-stats mb-3"></div>
      <div className="skeleton skeleton-recommended-programs mb-3"></div>
    </div>
  );
};

export default SkeletonLoading;